import { motion } from "framer-motion";

const easeOut = [0.22, 1, 0.36, 1];

// Slow, subtle fade + rise. Used across sections for scroll reveals.
export function Reveal({
    children,
    delay = 0,
    y = 26,
    className = "",
    as = "div",
    once = true,
}) {
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-10% 0px -10% 0px" }}
            transition={{ duration: 1.1, ease: easeOut, delay }}
        >
            {children}
        </MotionTag>
    );
}

// Line-wise masked reveal for large serif headings.
export function LineReveal({ lines, className = "", delay = 0, active = true }) {
    return (
        <span className={className} style={{ display: "block" }}>
            {lines.map((line, i) => (
                <motion.span
                    key={i}
                    style={{ display: "block", willChange: "clip-path, transform" }}
                    initial={{
                        clipPath: "inset(0 0 105% 0)",
                        y: 12,
                        opacity: 0,
                    }}
                    animate={
                        active
                            ? { clipPath: "inset(0 0 -12% 0)", y: 0, opacity: 1 }
                            : {}
                    }
                    transition={{
                        duration: 1.15,
                        ease: easeOut,
                        delay: delay + i * 0.14,
                    }}
                >
                    {line}
                </motion.span>
            ))}
        </span>
    );
}
